import React from 'react';

function Globe({
  lineColor = '#9FA3B3',
  width = 14,
  height = 14,
  style = {}
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      style={{ ...style }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.12397 12.8083C8.77952 11.8181 9.62162 10.0834 9.76057 7.61122H12.7188C12.4941 10.1961 10.5953 12.2995 8.12397 12.8083ZM1.21436 7.61122H4.21036C4.34686 10.1244 5.15116 11.8283 5.79306 12.8049C3.32976 12.2927 1.43836 10.1893 1.21436 7.61122ZM5.75841 1.40674C5.08466 2.39357 4.25761 4.10772 4.19706 6.58674H1.21436C1.43696 4.02577 3.31226 1.9326 5.75841 1.40674ZM5.24505 6.58742C5.31715 3.91718 6.39095 2.24059 6.96495 1.53376C7.547 2.25083 8.64145 3.94791 8.72545 6.58742H5.24505ZM6.96067 12.6444C6.41153 11.9273 5.42208 10.2815 5.26213 7.61122H8.70892C8.54617 10.2098 7.52067 11.9034 6.96067 12.6444ZM12.7188 6.58727H9.77251C9.70181 4.13556 8.84921 2.40093 8.16636 1.40386C10.6167 1.92629 12.4955 4.02288 12.7188 6.58727ZM6.97277 0.249512C6.97172 0.249512 6.97067 0.249512 6.96962 0.249512C6.96857 0.249512 6.96752 0.249512 6.96647 0.249512C3.20152 0.249512 0.138672 3.32268 0.138672 7.09927C0.138672 10.8793 3.20152 13.9524 6.96647 13.9524C10.7314 13.9524 13.7943 10.8793 13.7943 7.09927C13.7943 3.3261 10.7349 0.252926 6.97277 0.249512V0.249512Z"
        fill={lineColor}
      />
    </svg>
  );
}

export default Globe;
